import { render } from "./WelcomeTour.vue?vue&type=template&id=6dffb006&scoped=true"
import script from "./WelcomeTour.vue?vue&type=script&lang=js"
export * from "./WelcomeTour.vue?vue&type=script&lang=js"

import "./WelcomeTour.vue?vue&type=style&index=0&id=6dffb006&lang=scss&scoped=true"
import "./WelcomeTour.vue?vue&type=style&index=1&id=6dffb006&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dffb006"]])

export default __exports__